import { NavigateFunction, NavigateOptions, To } from 'react-router-dom';
// import logger from '../utils/logger/logger';
// import gaTracker from '../utils/GATracker/GATrackerSingleton';

class NavigationManager {
  private navigate: NavigateFunction | null = null;

  static routeToLabel(route: To): string | undefined {
    if (typeof route === 'string') {
      const parts = route.replace(/^\//, '').split('/');

      return parts
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ');
    }
    return undefined;
  }

  setNavigate(navigateFunction: NavigateFunction) {
    this.navigate = navigateFunction;
  }

  goTo(route: To, options?: NavigateOptions) {
    if (this.navigate) {
      this.navigate(route, options);
      // if (process.env.NODE_ENV === 'production') {
      //   gaTracker.trackPageView(
      //     route.toString(),
      //     NavigationManager.routeToLabel(route),
      //   );
      // }
    } else {
      // logger.error('Navigate function is not set yet.');
    }
  }

  go(delta: number) {
    if (this.navigate) {
      this.navigate(delta);
    } else {
      // logger.error('Navigate function is not set yet.');
    }
  }
}

const navigationManager = new NavigationManager();

export { NavigationManager };
export default navigationManager;
